import { BaseModal, ModalOptions, ModalResultType } from "../../../../../core/modal/index";
import { Template } from "../../../../../core/template/index";
import { ReceiveItemView } from "../../receive/partials/receive_item";

export default class ReceiveQuantityModal extends BaseModal
{
    public template = Template.lazy('/app/views/package_tracking/modals/receive_quantity/index.html');
    
    scannedItem: ReceiveItemView;
    receiveForm: HTMLFormElement;

    quanityInput: HTMLInputElement;

    constructor(item: ReceiveItemView)
    {
        super(item.item);
        this.scannedItem = item;
    }

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('Title', 'Receive package')
        }
    }

    public afterRender(): PromiseLike<void>
    {
        this.element.querySelectorAll('input').forEach(element => {
            element.addEventListener('focus', function () {
                this.select();
            });
        });
        return super.afterRender();
    }

    public onCancelClicked(e: Event)
    {
        this.close(ModalResultType.CANCEL);
    }

    public onSubmit(event: Event)
    {
        event.preventDefault();
        this.scannedItem.updateItemData(this.data);
        this.close(ModalResultType.OK);
    }
}